import React from 'react';
import { Radio, Database, ShieldAlert, FlaskConical } from 'lucide-react';

/**
 * TruthStateBadge — a small, consistent "where did this data come from" label.
 * Modes: LIVE (verified live feed), CACHED (last good snapshot), FALLBACK
 * (safe baseline while feeds reconnect), SCENARIO (illustrative / educational
 * example, not live). Keeps the app honest about data on every live-data panel.
 */
const STATES = {
  LIVE: { label: 'Live', Icon: Radio, cls: 'border-green-400/40 text-green-300 bg-green-400/10', dot: 'bg-green-400' },
  CACHED: { label: 'Cached', Icon: Database, cls: 'border-blue-400/40 text-blue-200 bg-blue-400/10', dot: 'bg-blue-400' },
  FALLBACK: { label: 'Fallback', Icon: ShieldAlert, cls: 'border-amber-400/40 text-amber-200 bg-amber-400/10', dot: 'bg-amber-400' },
  SCENARIO: { label: 'Scenario', Icon: FlaskConical, cls: 'border-mentor-border/60 text-mentor-muted bg-white/[0.03]', dot: 'bg-mentor-muted/50' },
};

export default function TruthStateBadge({ mode = 'SCENARIO', provider, asOf, note, className = '' }) {
  const s = STATES[mode] || STATES.SCENARIO;
  const { Icon } = s;
  return (
    <div className={`rounded-xl border ${s.cls} px-3 py-2 ${className}`}>
      <div className="flex items-center gap-2 flex-wrap">
        <span className="inline-flex items-center gap-1.5 text-xs font-display font-bold uppercase tracking-wider">
          <span className={`h-2 w-2 rounded-full ${s.dot} ${mode === 'FALLBACK' ? 'animate-pulse' : ''}`} />
          <Icon size={13} /> {s.label}
        </span>
        {provider && <span className="text-[11px] text-mentor-muted">· {provider}</span>}
        {asOf && <span className="text-[11px] text-mentor-muted">· {asOf}</span>}
      </div>
      {note && <p className="text-[11px] text-mentor-muted/90 leading-relaxed mt-1">{note}</p>}
    </div>
  );
}
